import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivateChild {

    constructor(private authService: AuthService, private router: Router) {}

    canActivateChild(): boolean {
        if(!this.authService.isLoggedIn){
            console.log('[auth]', 'login redirect');
            this.router.navigateByUrl('/admin/login');
        }
        return true;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/auth-gard.service.ts